export default "__VITE_ASSET__8f36b0c3__"